import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "./../../../ApiUrl";
import Swal from "sweetalert2";
import { Card, Container, FormGroup, Label,  } from "reactstrap";
import "./form.css"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  kategori_pendaftar: yup.string().required("Pilih kategori pendaftar"),
  name: yup.string().required("Nama wajib diisi"),
  email: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  phone: yup.string().required("Nomor wajib diisi"),
  province: yup.string().required("Pilih provinsi"),
  kabupaten: yup.string().required("Pilih kabupaten/kota"),
  alamat: yup.string().required("Alamat wajib diisi"),  
  code_recommender: yup.string().required("Pilih recomender"),
  sumber_informasi: yup.string().required("Pilih sumber informasi"),
  username: yup.string().required("Username wajib diisi"),  
  password: yup.string().required("Password wajib diisi"),

  nama_pimpinan: yup.string().when("kategori_pendaftar", {
    is: "2",
    then: (schema) => schema.required("Nama pimpinan wajib diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),

  jabatan: yup.string().when("kategori_pendaftar", {
    is: "2",
    then: (schema) => schema.required("Jabatan wajib diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),  
});

function Form() {

  const [dataPropinsi, setDataPropinsi] = useState([]);
  const [dataKabkota, setDataKabkota] = useState([]);
  const [dataKabkotafilter, setDataKabkotafilter] = useState([]);
  const [dataBizDev, setDataBizDev] = useState([]);
  const [formInstitution, setFormInstitution] = useState("none");
  const [showPassword, setShowPassword] = useState(false);
  const [btnText, setBtnText] = useState("Submit");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({ 
    resolver: yupResolver(schema),
    defaultValues: {
      kategori_pendaftar: "",
      name: "",
      jabatan: "",
      email: "",
      phone: "",
      nama_pimpinan: "",
      province: "",
      kabupaten: "",
      alamat: "",
      code_recommender: "",
      sumber_informasi: "",
      username: "",
      password: "",
    },    
   });  

  const kategoriPendaftar = watch("kategori_pendaftar");
  const idProvinsi = watch("province");

  
  // Toggle formInstitution visibility
  useEffect(() => {
    setFormInstitution(kategoriPendaftar === "2" ? "" : "none");
  }, [kategoriPendaftar]);

  // Fetch data
  useEffect(() => {
    getBizdev();
    getDataPropinsi();
    getDataKabkota();
  }, []);

  const getDataPropinsi = async () => {
    try {
      const res = await axios.get(`${API_URL.superStudent}/api/v1/application/master/provinces`);
      setDataPropinsi(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getDataKabkota = async () => {
    try {
      const res = await axios.get(`${API_URL.superStudent}/api/v1/application/master/kabupaten`);
      setDataKabkota(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getBizdev = async () => {
    try {
      const formData = new FormData();
      formData.append("jobdesk", JSON.stringify(["JD002","JD007", "JD016", "JD030"]));
      const res = await axios.post(`${API_URL.superStudent}/ambassador/consultant/jobdesk`, formData, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${API_URL.ambassadorKey}`,
        },
      });
      setDataBizDev(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Filter kabupaten berdasarkan propinsi
  useEffect(() => {
    if (idProvinsi) {
      const filtered = dataKabkota.filter((k) => k.province_id == idProvinsi);
      setDataKabkotafilter(filtered);
    }
  }, [idProvinsi, dataKabkota]);  

  // Toggle show password
  const togglePassword = () => setShowPassword(!showPassword);

  // Submit data ke API
  const sendData = async (data) => {
    setBtnText("Sending ...");

    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, val]) => formData.append(key, val));
      formData.append("code_roles", "RL008");

      const res = await axios.post(`${API_URL.superStudent}/ambassador/registration`, formData, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${API_URL.ambassadorKey}`,
        },
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Your data has been saved",
          showConfirmButton: false,
          timer: 3000,
        });
        reset();
      } else {
        Swal.fire({ icon: "error", title: res.data.message });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Terjadi kesalahan saat mengirim data" });
    } finally {
      setBtnText("Submit");
    }
  };

  // Handle perubahan kategori
  useEffect(() => {
    if (kategoriPendaftar === "2") setFormInstitution("");
    else setFormInstitution("none");
  }, [kategoriPendaftar]);  


  return (
    <section id="form" className="form py-5">
      <Container>
        <h1 className="text-center pb-2">Daftar di Sini</h1>
        <div className="form-wrapper">
          <Card className="card-form p-4">
            <form onSubmit={handleSubmit(sendData)}>
              <FormGroup>
                <Label htmlFor="kategori_pendaftar">Kategori Pendaftar</Label>
                <select id="kategori_pendaftar" {...register("kategori_pendaftar")} className="form-control" >
                  <option value="">--Pilih Kategori--</option>
                  <option value="1">Personal</option>
                  <option value="2">Institution</option>
                </select>
                <span style={{ color: "red" }}>{errors.kategori_pendaftar?.message}</span>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="name">Nama {kategoriPendaftar === "2" ? "Instansi" : "Lengkap"}</Label>
                <input id="name" {...register("name")} className="form-control" />
                <span style={{ color: "red" }}>{errors.name?.message}</span>
              </FormGroup>

              <div style={{ display: formInstitution }}>
                <FormGroup>
                  <Label htmlFor="nama_pimpinan">Nama Pimpinan</Label>
                  <input id="nama_pimpinan" {...register("nama_pimpinan")} className="form-control" />
                  <span style={{ color: "red" }}>{errors.nama_pimpinan?.message}</span>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="jabatan">Jabatan</Label>
                  <input id="jabatan" {...register("jabatan")} className="form-control" />
                  <span style={{ color: "red" }}>{errors.jabatan?.message}</span>
                </FormGroup>
              </div>

              {/* Email */}
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <input id="email" {...register("email")} type="email" className="form-control" />
                <span style={{ color: "red" }}>{errors.email?.message}</span>
              </FormGroup>

              {/* Phone */}
              <FormGroup>
                <Label htmlFor="phone">Phone / Whatsapp</Label>
                <input id="phone" {...register("phone")} className="form-control" type="text" />
                <span style={{ color: "red" }}>{errors.phone?.message}</span>
              </FormGroup>

              {/* Provinsi */}
              <FormGroup>
                <Label htmlFor="province">Provinsi</Label>
                <select id="province" {...register("province")} className="form-control" name="province" >
                  <option value="">--Pilih Propinsi--</option>
                  {dataPropinsi.map((p) => (
                    <option key={p.id} value={p.id}>{p.province_name}</option>
                  ))}
                </select>
                <span style={{ color: "red" }}>{errors.province?.message}</span>
              </FormGroup>

              {/* Kab/Kota */}
              <FormGroup>
                <Label htmlFor="kabupaten">Kab / Kota</Label>
                <select id="kabupaten" {...register("kabupaten")} className="form-control" >
                  <option value="">--Pilih Kab/Kota--</option>
                  {dataKabkotafilter.map((k) => (
                    <option key={k.id} value={k.id}>{k.kabupaten_name}</option>
                  ))}
                </select>
                <span style={{ color: "red" }}>{errors.kabupaten?.message}</span>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="alamat">Alamat Lengkap</Label>
                <input id="alamat" {...register("alamat")} className="form-control" />
                <span style={{ color: "red" }}>{errors.alamat?.message}</span>
              </FormGroup>              

              {/* Recommender */}
              <FormGroup>
                <Label htmlFor="code_recommender">Recommender</Label>
                <select id="code_recommender" {...register("code_recommender")} className="form-control" >
                  <option value="">--Pilih Recommender--</option>
                  {dataBizDev.map((b) => (
                    <option key={b.code_konsultan} value={b.code_konsultan}>{b.nama}</option>
                  ))}
                </select>
                <span style={{ color: "red" }}>{errors.code_recommender?.message}</span>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="sumber_informasi">Darimana Mengetahui NIEC</Label>
                <select id="sumber_informasi" {...register("sumber_informasi")} className="form-control" >
                  <option value="">--Pilih Sumber--</option>
                  <option value="Sosial Media">Sosial Media</option>
                  <option value="Website">Website</option>
                  <option value="Staf NIEC">Staf NIEC</option>
                  <option value="Google">Google</option>
                  <option value="Ambassador Lainnya">Ambassador Lainnya</option>
                </select>
                <span style={{ color: "red" }}>{errors.sumber_informasi?.message}</span>
              </FormGroup>

              {/* Username + Password */}
              <FormGroup>
                <Label htmlFor="username">Username</Label>
                <input {...register("username")} id="username" className="form-control" />
                <span style={{ color: "red" }}>{errors.username?.message}</span>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="password">Password</Label>
                <input
                  {...register("password")}
                  id="password"
                  className="form-control"
                  name="password"
                  type={showPassword ? "text" : "password"}
                />
                <div className="col-sm-1">
                  <span className="fa fa-fw fa-eye field-icon toggle-password" onClick={togglePassword}></span>
                </div>
                <span style={{ color: "red" }}>{errors.password?.message}</span>
              </FormGroup>
              <div className="d-grid">
                <input type="submit" value={btnText} className="btn-custom3"/>
              </div>            
            </form>
          </Card>
        </div>
      </Container>
    </section>
  );
}

export default Form;